import { gql } from 'graphql-tag';
export default gql`
    fragment HtmlBlockFragment on HtmlBlock {
        blockName
        blockType
        html
    }
`;
